<template>
  <div
    class="child-course-block"
    :style="blockStyle"
  >
    <child-course
      v-for="(childCourse, childCourseIndex) in childCourses"
      :key="childCourseIndex"
      :show-course-time="showCourseTime"
      :show-instructors="showInstructors"
      :invisible-parent-courses="invisibleParentCourses"
      :day-of-week-visible="dayOfWeekVisible"
      :child-course="childCourse"
      :block-start="blockStart"
      :block-end="blockEnd"
      :block-height="blockHeight"
      :font-size="fontSize"
      :sub-font-size="subFontSize"
      @init="onInitChildCourse"
    />
  </div>
</template>

<script>
import ChildCourse from "./ChildCourse";
import HourMinutes from "./hourMinutes";

// 7시부터 11시까지
export default {
	name: "ChildCourseBlock",
	components: { ChildCourse },
	props: {
		childCourses: {
			type: Array,
		},
		startTime: {},
		endTime: {},
		blockHeight: {
			default: 300,
		},
		showCourseTime: {},
		showInstructors: {},
		invisibleParentCourses: {},
		dayOfWeekVisible: {},
		fontSize: {},
		subFontSize: {},
	},
	data() {
		return {};
	},
	computed: {
		blockStyle() {
			return {
				height: `${this.blockHeight}px`,
			};
		},
		blockStart() {
			return new HourMinutes(this.startTime);
		},
		blockEnd() {
			return new HourMinutes(this.endTime);
		},
	},
	methods: {
		onInitChildCourse(childCourse) {
			this.$emit("init", childCourse);
		},
	},
};
</script>

<style lang="scss">
.child-course-block {
	position: relative;
}
</style>
